<template lang="pug">
  .height-100
    .modal.is-active(
      v-if="mostrarModalAsignarAsistenteExterno"
      :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
    )
      .modal-background(@click="mostrarModalAsignarAsistenteExterno = false")
      .card
        header.modal-card-head.display-flex
          p.flex-1
            span(v-if="asistenteExterno.id") Actualizar asistente externo
            span(v-else) Insertar asistente interno
        .card-content
          .title
            .display-flex.fdc
              .control.margin-bottom-10.flex-1
                p.margin-bottom-5 Nombre
                input.input(
                  type="text",
                  v-model="asistenteExterno.nombreExterno"
                  :disabled="isSaving"
                )
              .control.margin-bottom-10
                p.margin-bottom-5 Cargo
                input.input(
                  type="text",
                  v-model="asistenteExterno.cargoExterno"
                  :disabled="isSaving"
                )
        footer.card-footer
          a.card-footer-item(@click="guardarAsistenteExterno")
            strong(v-if="isSaving") Guardando...
            strong(v-else) Guardar
          a.card-footer-item( @click="closeModalAsignarAsistenteExterno")
            span Cancelar
    .modal.is-active(
      v-if="mostrarModalAsignarEmpleado"
      :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
    )
      .modal-background(@click="mostrarModalAsignarEmpleado = false")
      transition(name='fade-quick')
        seleccionar-empleado(
          :fetchEndpoint="fetchEndpoint"
          :filtroProp="filtroAsignarEmpleado"
          :asignarEmpleadosEndpoint="asignarEmpleadosEndpoint"
          :desasignarTodosEndpoint="desasignarTodosEndpoint"
          :asignarTodosEndpoint="asignarTodosEndpoint"
          :objAux="objAux"
          @close="closeModalAsignarEmpleado()"
        )
    .title.pt-5
      span Asistentes
    .text-center
      button.button.is-small.is-primary.mb-5(@click="abrirModalAsignarEmpleados({})" v-if="!(esReunionTerminada || esReunionAnulada)")
        span.icon.is-small
          i.fa.fa-users.is-small
        span Asignar Empleados
      button.button.is-small.is-primary.mb-5.ml-5(@click="abrirModalAsignarAsistenteExterno({})" v-if="!(esReunionTerminada || esReunionAnulada)")
        span.icon.is-small
          i.fa.fa-users.is-small
        span Agregar Externo
    .body
      .data.overflow-y-scroll
        transition-group.contenedor-data(v-infinite-scroll="fetchByScroll" infinite-scroll-disabled="disabledScrollExecute" infinite-scroll-distance="2" name="fade-smooth-two" tag="div")
          .asistentes-item.position-relative(
            v-for="(o, index) in lista"
            :key="'asistente_' + index"
            @dblclick="abrirModalAsignarEmpleados(o)"
          )
            .asistentes-item-container.display-flex
              .display-flex.fdc.flex-1
                .asistentes-name
                  span {{ o.nombre || o.nombreExterno }}
                .asistentes-cargo
                  span {{ o.cargo || o.cargoExterno}}
                  span.externo-span(v-if="o.externo") &nbsp (Externo)
              .asistentes-checkbox
                template(v-if="o.externo && !esReunionTerminada && !esReunionAnulada")
                  button.button.is-small.m-2(@click="abrirModalAsignarAsistenteExterno(o)")
                    span.icon.is-small
                      i.fa.fa-pencil-square-o
                  button.button.is-small.m-2.is-danger(@click="borrarAsistenteExterno(o)")
                    span.icon.is-small
                      i.fa.fa-trash
                label.checkbox(v-if="esReunionTerminada")
                  input.checkbox(
                    type="checkbox"
                    name="asistio"
                    v-model="o.asistio"
                    @change="changeCheckbox($event,o)"
                    :disabled="!esReunionTerminada || codigoCreador === o.codigo || isSaving"
                  )
                  span.ml-5 Asistió
        div(v-if="lista.length === 0" key="message_warning")
          .message.is-warning
            .message-body No hay alumnos registrados
        .is-loading(v-if="isLoading" key="loading_spin")
          .icon
            i.fa.fa-spinner.fa-spin

</template>

<script>
import ComponentConfirmarAccionOverlay from './Component_Confirmar_Accion_Overlay';
import SeleccionarEmpleado from './lookups/Empleados_Multiple';
import { apiGet, notify, apiDelete, apiPost, apiPut } from '../util/general'
export default {
  name: 'c_asistentes_externos_internos_lista',
  props: ['codigoCreador', 'esReunionTerminada', 'esReunionAnulada'],
  data () {
    return {
      lista                           : [],
      isLoading                       : false,
      isSendingEliminar               : false,
      disabledScrollExecute           : true,
      mostrarModalAsignarEmpleado     : false,
      mostrarModalAsignarAsistenteExterno: false,
      skip                            : 0,
      noMore                          : false,
      filtroAsignarEmpleado           : '',
      objAux                          : { idReunion: this.idReunion },
      nombreCreador                   : localStorage.getItem('nombre'),
      cambiosAsistencia          : [],
      isSaving: false,
      asistenteExterno: {
        nombreExterno:'',
        cargoExterno:''
      }
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    idReunion () {
      return +this.$route.params.idReunion
    },
    baseEP () {
      return '/reunion/gestion/' + this.idReunion
    },
    fetchEndpoint () {
      return this.baseEP + '/asistente/asignar'
    },
    asignarEmpleadosEndpoint () {
      return this.baseEP + '/asistente/asignar'
    },
    asignarTodosEndpoint () {
      return this.baseEP + '/asistente/asignar-todos'
    },
    desasignarTodosEndpoint () {
      return this.baseEP + '/asistente/desasignar-todos'
    }
  },
  components: {
    'confirmar-accion-overlay' : ComponentConfirmarAccionOverlay,
    'seleccionar-empleado':SeleccionarEmpleado
  },
  created () {
  },
  mounted () {
    var vm = this
    if (vm.idReunion) {
      vm.fetch()
    } else {
      vm.lista.push({nombre:vm.nombreCreador})
    }
  },
  methods: {
    abrirModalAsignarAsistenteExterno (o) {
      var vm = this
      vm.asistenteExterno = {...o}
      vm.mostrarModalAsignarAsistenteExterno = true
    },
    changeCheckbox (e, row) {
      const isChecked = e.target.checked
      const nombre = row.nombreExterno
      this.registrarCambioAsistencia(row.codigo, nombre, isChecked)
    },
    registrarCambioAsistencia (codigo, nombre, nuevoEstado) {
      console.log(codigo, nombre, nuevoEstado)
      const index = this.cambiosAsistencia.findIndex((asistente) => {
        return asistente.codigo === codigo || asistente.nombre === nombre
      });
      if (index !== -1) {
        this.cambiosAsistencia[index].asistio = nuevoEstado;
      } else {
        // this.cambiosAsistencia.push({ codigo, nombre, asistio: nuevoEstado });
        if (codigo) this.cambiosAsistencia.push({ codigo, asistio: nuevoEstado });
        else this.cambiosAsistencia.push({ nombre, asistio: nuevoEstado });
      }
      console.log(this.cambiosAsistencia)
    },
    closeModalAsignarEmpleado () {
      this.mostrarModalAsignarEmpleado = false
      this.fetch()
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      vm.disabledScrollExecute = true
      vm.noMore = false
      var obj = {}
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, vm.baseEP + '/asistente', obj, function (data) {
        data.lista.forEach(function (o) {
          vm.lista.push(o)
        })
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip = data.numeroRecnum
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.disabledScrollExecute = true
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    abrirModalAsignarEmpleados (o) {
      var vm = this
      if (vm.esReunionTerminada || vm.esReunionAnulada) {
        return
      }
      if (!vm.idReunion) {
        vm.$emit('save')
        return
      }
      if (o.externo) {
        vm.asistenteExterno = o
        vm.mostrarModalAsignarAsistenteExterno = true
        return
      }
      const dni = o ? o.dni : ''
      vm.filtroAsignarEmpleado = dni
      this.mostrarModalAsignarEmpleado = true
    },
    guardarAsistentes () {
      var vm = this
      if (!vm.esReunionTerminada) return
      vm.isSaving = true
      apiPut(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/marcar-asistencia', {asistentes: vm.cambiosAsistencia}, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha marcado la asistencia correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    guardarAsistenteExterno () {
      var vm = this

      if (!vm.asistenteExterno.nombreExterno) return notify(vm, 'error', 'Error', 'Escriba un nombre.')
      if (!vm.asistenteExterno.cargoExterno) return notify(vm, 'error', 'Error', 'Escriba un cargo.')

      if (vm.asistenteExterno && vm.asistenteExterno.id) {
        vm.actualizarAsistenteExterno()
      } else {
        vm.insertarAsistenteExterno()
      }
    },
    closeModalAsignarAsistenteExterno () {
      var vm = this
      vm.mostrarModalAsignarAsistenteExterno = false
      vm.asistenteExterno = {}
    },
    insertarAsistenteExterno () {
      var vm = this
      vm.isSaving = true
      apiPost(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/gestion/0/asignar/externo', {...vm.asistenteExterno}, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha insertado el asistente correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        vm.closeModalAsignarAsistenteExterno()
        vm.fetch()
      })
    },
    actualizarAsistenteExterno () {
      var vm = this
      vm.isSaving = true
      apiPut(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/gestion/' + vm.asistenteExterno.id + '/asignar/externo', {...vm.asistenteExterno}, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha actualizado el asistente correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        vm.closeModalAsignarAsistenteExterno()
        vm.fetch()
      })
    },
    borrarAsistenteExterno (o) {
      var vm = this
      vm.isSaving = true
      apiDelete(vm, '/reunion/gestion/' + vm.idReunion + '/asistente/gestion/' + o.id + '/asignar/externo', {}, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha borrado el asistente correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        vm.fetch()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .creator-tag
    position absolute
    font-size 9px
    top -2px
    right 1px
    color #565cde

  .data
    max-height 250px
    overflow-y auto
    // scrollbar-width: none; /* Firefox */
    padding 2px
    // &::-webkit-scrollbar
    //   display none // Ocultar barra en Chrome, Safari y navegadores Webkit
    .usuario
      background #fff
      border-radius 3px
      border 1px solid #d6dadc
      border-bottom-color #c4c9cc
      -webkit-box-shadow 0 1px 6px rgba(0,0,0,.15)
      box-shadow 0 1px 6px rgba(0,0,0,.15)
      padding 10px
      margin-bottom 5px
      cursor pointer
      transition all .2s ease
      width 100%
      max-width: 290px
      &:hover
        background-color #edeff0
        margin-left 4px
        -webkit-box-shadow -8px 0 #959da17d
        box-shadow -8px 0 #959da17d
      span.italic
        text-align left
      .contenedor-acciones
        padding-left 1em
    .asistentes-item
      .asistentes-item-container
        display flex
        margin-bottom 5px
        max-width 300px
        min-width 300px
        width 100%
        text-align left
        .asistentes-name
          font-size 14px
          font-weight bold
          flex 1
        .asistentes-cargo
          font-size 11px
          color #a9a9a9
          .externo-span
            color #be8fe4
    .contenedor-box
      >*
        transition all .5s
        width 100%
  .is-mobile
    .is-close
      background-color #ffd6d6 !important
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      // span
      //   font-weight bold
      //   text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display block
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  // @media (max-width 400px)
  //   .is-mobile
  //     display block

  //   .is-desktop
  //     display none
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width: 500px)
    .data
      .usuario
        width: 100%;
        max-width: 100%;
        min-width: 100%;
</style>




// WEBPACK FOOTER //
// Lista_Asistentes_Empleados_Multiple.vue?232772c6